const conditions = [
  "Weight Loss",
  "Insulin Resistance",
  "Type 2 Diabetes",
  "PCOD / PCOS",
  "Gut Health",
  "Thyroid Disorders",
  "NAFLD",
  "Blood Pressure",
  "Hormonal Imbalance",
  "Metabolic Syndrome",
  "Weight Gain",
];

export const ConditionsMarquee = () => {
  const loop = [...conditions, ...conditions];
  return (
    <section
      data-testid="conditions-marquee"
      aria-label="Conditions we address"
      className="border-y border-[#D5CEBA] bg-[#FCFBF7] py-8 overflow-hidden"
    >
      <div className="flex whitespace-nowrap marquee-track">
        {loop.map((c, i) => (
          <span
            key={`${c}-${i}`}
            className="flex items-center gap-8 px-8 font-display text-3xl lg:text-5xl text-[#1E3A2B]"
          >
            {c}
            <span
              aria-hidden
              className="inline-block w-2 h-2 rounded-full bg-[#C25E3E]"
            />
          </span>
        ))}
      </div>
    </section>
  );
};

export default ConditionsMarquee;
